import { PATHS } from 'helpers/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as Araks } from '../icons/araks.svg';

type Props = {
  margin?: string;
  isExternal?: boolean;
};

export const Logo = ({ margin, isExternal = false }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdminPath = location.pathname.includes('admin');

  return (
    <Araks
      style={{ cursor: 'pointer', ...(margin ? { margin } : {}) }}
      onClick={() => (isExternal ? false : isAdminPath ? navigate(PATHS.ADMIN) : navigate(PATHS.PROJECTS))}
    />
  );
};
